import { Layout } from 'antd';

const Divider = () => {
  return <span style={{ margin: '0 0.5rem' }}>|</span>;
};

export function Footer() {
  return (
    <Layout.Footer style={{ margin: 'auto', paddingTop: 10, paddingBottom: 10 }}>
      <a href="https://wiki.ith.intel.com/display/SAAFWIKI" target="_blank" rel="noreferrer">
        Wiki
      </a>
      <Divider />
      <a
        href="https://wiki.ith.intel.com/pages/viewpage.action?pageId=2921324449#Help!-ReportanIssue"
        target="_blank"
        rel="noreferrer"
      >
        Report an Issue
      </a>
      <Divider />
      <a
        href="https://wiki.ith.intel.com/pages/viewpage.action?pageId=2921324449#Help!-RequestanEnhancement"
        target="_blank"
        rel="noreferrer"
      >
        Request an Enhancement
      </a>
      <Divider />
      <a
        href="https://circuit.intel.com/content/corp/Global_Employee_and_Global_Contingent_Worker_Privacy.html"
        target="_blank"
        rel="noreferrer"
      >
        Employee/Contingent Worker Privacy
      </a>
      <Divider />
      Intel Confidential
      <Divider />© Intel Corporation
    </Layout.Footer>
  );
}
export default Footer;
